import react from "react";
import styles from "./styles.module.scss"
import { Link } from "react-router-dom";
import data, { transportType } from "../../../common/data";

const Schedule = () => {
    return(
        <>
            <div className={styles["schedule"]}>
                <Link to={'/'} className={styles["link-to-home"]}><span>&lt;</span>Главная страница</Link>
                <h1 className={styles["location"]}>Расписание <span>Волгоград</span></h1>
                <div className={styles["types"]}>
                        <h1>Автобусы</h1>
                        <div className={styles['numbers']}>
                            {data.bus.properties.vstu.map(bus => {
                                if(bus.type === "Автобус"){
                                    return(
                                        <div className={styles["number"]}>
                                            <span>{bus.name}</span>
                                        </div>
                                    )
                                }
                            })}
                        </div>
                </div>
                <div className={styles["types"]}>
                        <h1>Троллейбусы</h1>
                        <div className={styles['numbers']}>
                            {data.bus.properties.vstu.map(bus => {
                                if(bus.type === "Троллейбус"){
                                    return(
                                        <div className={styles["number"]}>
                                            <span>{bus.name}</span>
                                        </div>
                                    )
                                }
                            })}
                        </div>
                </div>
                <div className={styles["types"]}>
                        <h1>Трамваи</h1>
                        <div className={styles['numbers']}>
                            {data.bus.properties.vstu.map(bus => {
                                if(bus.type === "Трамвай"){
                                    return(
                                        <div className={styles["number"]}>
                                            <span>{bus.name}</span>
                                        </div>
                                    )
                                }
                            })}
                        </div>
                </div>
                <div className={styles["types"]}>
                        <h1>Маршрутные такси</h1>
                        <div className={styles['numbers']}>
                            {data.bus.properties.vstu.map(bus => {
                                if(bus.type === "Маршрутка"){
                                    return(
                                        <div className={styles["number"]}>
                                            <span>{bus.name}</span>
                                        </div>
                                    )
                                }
                            })}
                        </div>
                </div>
            </div>
            
        </>
    )
};

export default Schedule;